import { LessonTypeType } from '@openeducation/oe-it-shared-types';
import axios from 'axios';

import type { Lesson } from '../interfaces';
import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class LessonsDao {
  static async getStudentLessonsByUnit(
    env: Environment,
    contactId: string,
    unitId?: number,
    lessonType?: LessonTypeType
  ) {
    const url = hostsConfig[env].courseServiceHost;
    const { data } = await axios.get<Lesson[]>(`${url}/v1/lessons`, {
      params: { contactId, unitId, lessonType },
    });
    return data;
  }
}
